export const getNumberRangeStep = (allowDecimals, inputType) => {
    if (!allowDecimals) {
        return '1';
    }
    if (inputType === 'volume') {
        return '0.0001';
    }
    return '0.001';
};

export const truncateToDecimalPlaces = (newValue, decimalPlaces) => {
    const parts = newValue.split('.');
    const decimalPart = parts[1] || '';
    if (decimalPart.length > decimalPlaces) {
        return `${parts[0]}.${decimalPart.substring(0, decimalPlaces)}`;
    }
    return newValue;
};

export const isUnlimitedDecimalType = (inputType) => inputType === 'volume' || inputType === 'price';

export const applyNumericBlur = ({ e, value, inputType, onBlurProp, applyRoundedBlurValue, roundVolumeInput, roundPriceInput }) => {
    const numValue = Number(value);
    if (!isNaN(numValue)) {
        if (inputType === 'volume') {
            applyRoundedBlurValue(e, roundVolumeInput(value));
            return;
        }
        if (inputType === 'price') {
            applyRoundedBlurValue(e, roundPriceInput(value));
            return;
        }
        if (e && e.target && value) {
            e.target.value = value;
        }
        if (onBlurProp) {
            onBlurProp(e);
        }
        return;
    }
    if (onBlurProp) {
        onBlurProp(e);
    }
};
